import {Component, OnInit, ViewChild, Optional, ViewContainerRef} from '@angular/core';
import {IosAppUserService} from '../../_services/ios-app-user.service';
import {CoinConfigService} from '../../_services/coinconfig.service';
import {DialogService} from 'ng2-bootstrap-modal';
import {AddIosAppUserComponent} from './add-ios-app-user/add-ios-app-user.component';
import {EditIosAppUserComponent} from './edit-ios-app-user/edit-ios-app-user.component';
import {ConfirmComponent} from '../../_common/confirm/confirm.component';
import {DataTableDirective} from 'angular-datatables';



@Component({
    selector: 'app-ios-app-user',
    templateUrl: './ios-app-user.component.html',
    styleUrls: []
})
export class IosAppUsersComponent implements OnInit {

    searchWord: string;
    delayTimer: any;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};

    constructor(
        private iosAppUserService: IosAppUserService,
        private dialogService: DialogService) {
    }

    ngOnInit() {
        this.registerTable();
    }

    registerTable() {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.searchWord || '';

                //assign parameters object
                self.parameters = parameters;

                //assign callback object
                self.callback = callback;

                self.iosAppUserService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: "ユーザー名",
                    data: "username",
                    name: "username",
                    className: "all text-justify"
                },

                {
                    title: "メール",
                    data: "email",
                    name: "email",
                    className: "text-justify"
                },

                {
                    title: "",
                    data: function (d) {
                        return `<button class="btn btn-sm btn-primary btn-edit">編集</button>`;
                    },
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    data: function (d) {
                        return `<button class="btn btn-sm btn-danger btn-delete">削除</button>`;
                    },
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;

                $('.btn-edit', row).bind('click', () => {
                    self.openEdit(data);
                });
                $('.btn-delete', row).bind('click', () => {
                    self.confirmDelete(data);
                });
                return row;
            }
        };
    }

    onChange(event) {
        // this.pairId = event.target.value;
        this.rerenderDataTable();
    }

    onChangeMarkets(event) {
        //this.marketId = event.target.value;
        this.rerenderDataTable();
    }

    valuechange(newValue) {
        this.searchWord = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    openModalAddMail() {
        let self = this;
        this.dialogService.addDialog(AddIosAppUserComponent).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.iosAppUserService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }

    confirmDelete(data) {
        this.dialogService.addDialog(ConfirmComponent, { 
            title: '確認', 
            message: '削除しますが、よろしいでしょうか？' 
        }).subscribe((isConfirmed) => {
            if (isConfirmed) {
                this.iosAppUserService.delete(data.id).subscribe(data => {
                    this.loadCurrentPage();
                }, error => {

                });
            }
        });
    }
    openEdit(data) {
        this.dialogService.addDialog(EditIosAppUserComponent,
             { userId: data.id, userName: data.username, email: data.email }
        ).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });;
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/ios-app-user/ios-app-user.component.ts